module.exports = __webpack_public_path__ + "static/img/ikona_galeria-OFF.9178deca.png";